import Editor from '@monaco-editor/react'
import { Box } from '@mui/material'

type TableAsJsonProps<T> = {
	entries: T[]
	height?: string
	width?: string
}

export const JsonDisplay = <T extends Record<string, unknown>>(props: TableAsJsonProps<T>) => {
	return (
		<Box width="100%">
			<Editor
				language="json"
				height={props.height ?? "65vh"}
				width={props.width}
				value={JSON.stringify(props.entries, null, 2)}
				options={{
					automaticLayout: true,
					minimap: {
						enabled: false,
					},
					fontSize: 16,
					domReadOnly: true,
					readOnly: true,
					lineNumbers: false,
					scrollBeyondLastLine: false,
				}}
			/>
		</Box>
	)
}
